import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useMeContext } from '~/modules/me';
import {
  hasAcceptActionAllowed,
  hasProposeActionAllowed
} from '~/modules/resourcing/common/components/ResourceMatchItem/permissionUtil';
import ResourceMatchAlternativeLink from './ResourceMatchAlternativeLink';
import ResourceMatchCancelLink from './ResourceMatchCancelLink';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  rootNoAllocationEditPermission: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));

export const ResourceMatchPopoverFooter = ({
  onClose,
  scale,
  displayUnit,
  resourceRequest,
  project
}) => {
  const classes = useStyles();
  const me = useMeContext();
  const showAlternativeLink =
    hasProposeActionAllowed(me) || hasAcceptActionAllowed(project);

  return (
    <div
      className={
        showAlternativeLink
          ? classes.root
          : classes.rootNoAllocationEditPermission
      }
    >
      {showAlternativeLink && (
        <ResourceMatchAlternativeLink
          resourceRequest={resourceRequest}
          scale={scale}
          displayUnit={displayUnit}
        />
      )}
      <ResourceMatchCancelLink onClose={onClose} />
    </div>
  );
};

ResourceMatchPopoverFooter.propTypes = {
  onClose: PropTypes.func.isRequired,
  resourceRequest: PropTypes.object,
  scale: PropTypes.string,
  displayUnit: PropTypes.string,
  project: PropTypes.object.isRequired
};

export default ResourceMatchPopoverFooter;
